import { Injectable } from '@angular/core';
import {MessageAttachment, MessageAttachmentList} from './message_attachment';
import {BaseService} from '../base/base.service';
import {MessageAttachmentSerializer} from 'src/app/message_attachments/message_attachment.serializer';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MessageAttachmentService extends BaseService<MessageAttachment, MessageAttachmentList> {

  constructor(http: HttpClient) {
    super(http);
    this.endpoint = 'message_attachments' ;
    this.serializer = new MessageAttachmentSerializer();
  }
}
